import { ROUTE } from './storyAdapter.js';

export function musicScene(phase, card, era) {
  const cue =
    {
      menu: 'title',
      story: card?.musicCue,
      briefing: 'plan',
      playing: ROUTE.musicCue,
      complete: ROUTE.outroCue,
    }[phase] ?? 'title';
  return {
    cue,
    era:
      era === 'fracture'
        ? 'fractured'
        : phase === 'story' && card?.tone === 'dawn'
          ? 'kingdom'
          : 'occupied',
    intensity: phase === 'playing' ? 0.25 : 0.4,
  };
}

/** Pressure near the two occupation searchlight crossings, not a detection claim. */
export function stealthIntensity(position, movement, sprint) {
  const distance = Math.min(Math.abs(position.z - 6), Math.abs(position.z + 26));
  const proximity = Math.max(0, 1 - distance / 9);
  return Math.min(0.95, 0.25 + Math.min(1, movement) * (sprint ? 0.3 : 0.1) + proximity * 0.35);
}
